import Icon from 'veui/components/Icon'
import { IconMinimize } from 'dls-icons-vue'

Icon.register('minimize', IconMinimize)
